import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AlertTypeEnum } from 'app/shared/enums/alert-type.enum';

@Component({
    selector: 'kh-alert',
    styleUrls: ['./alert.component.less'],
    templateUrl: './alert.component.html',
    standalone: false
})
export class AlertComponent {
  @Input() public title: string = '';
  @Input() public type: AlertTypeEnum = AlertTypeEnum.Danger;
	@Input() public showCloseButton: boolean = false;
	@Output() public onCloseCallBack = new EventEmitter();

  public alertTypeEnum = AlertTypeEnum;

  public getClass(): string {
    switch (this.type) {
      case AlertTypeEnum.Danger:
        return 'error-message';
      case AlertTypeEnum.Warning:
        return 'warning-message';
      case AlertTypeEnum.Info:
        return 'info-message';
      default:
        return '';
    }
  }

	public closeAlert() {
		this.onCloseCallBack.emit();
	}
}
